import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: { marginBottom: 20 },
  titleStyle: theme => ({
    fontSize: 16.7,
    lineHeight: 23,
    fontWeight: 'normal',
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.headerColor,
  }),
  subtitle: theme => ({
    fontSize: 28,
    lineHeight: 36,
    fontWeight: 'bold',
    marginTop: 8,
    color: theme.colors.headerColor,
  }),
  rightText: { paddingTop: 0, lineHeight: 16 },
  orderDate: theme => ({
    marginBottom: 22,
    fontSize: 16.7,
    letterSpacing: 0,
    color: theme.colors.headerColor,
  }),
  QAMtitle: {
    fontSize: 19,
    letterSpacing: -0.29,
    alignSelf: 'center',
    marginTop: 10,
  },
  QAMContainerStyle: { paddingHorizontal: 0 },
  sectionHeaderContainerStyle: { marginTop: Platform.OS === 'ios' ? 40 : 32 },
});
